
import React from 'react';
import ComplianceScore from './ComplianceScore';

export interface ComplianceCategoryProps {
  id: number;
  name: string;
  progress: number;
  total: number;
  completed: number;
  pending: number;
}

interface ScoreGridProps {
  categories: ComplianceCategoryProps[];
}

const ScoreGrid: React.FC<ScoreGridProps> = ({ categories }) => {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
      {categories.map((category) => (
        <ComplianceScore
          key={category.id}
          name={category.name}
          progress={category.progress}
          completed={category.completed}
          pending={category.pending}
        />
      ))}
    </div>
  );
};

export default ScoreGrid;
